import {actions as A} from '../../modules/Inspection/constants/actions';
import {PURGE} from 'redux-persist';

const defaultState = {
  cities: {
    list: [],
    loading: false,
    error: false,
    errorMessage: null
  },
  streets: {
    list: [],
    loading: false,
    error: false,
    errorMessage: null
  },
};

export default (state = defaultState, {type, payload}) => {
  switch (type) {
    case A.GET_CITIES:
      return {...state, cities: {...state.cities, loading: true, list: null}};

    case A.GET_CITIES_SUCCESS:
      return {...state, cities: {...state.cities, loading: false, list: payload}};

    case A.GET_CITIES_FAILURE:
      return {...state, cities: {...state.cities, loading: false, error: true, errorMessage: payload.errorMessage}};

    case A.GET_STREETS:
      return {...state, streets: {...state.streets, loading: true, list: null}};

    case A.GET_STREETS_SUCCESS:
      return {...state, streets: {...state.streets, loading: false, list: payload}};

    case A.GET_STREETS_FAILURE:
      return {...state, streets: {...state.streets, loading: false, error: true, errorMessage: payload.errorMessage}};

    case A.CLEAR_INSPECTION:
      return {...defaultState, cities: {...state.cities}};

    case PURGE: {
      return {...defaultState}
    }

    default:
      return state;
  }
}
